import { AssetAppealRequestActionStatusEnum } from "types";
import "./CourtInforCardCss.css";
import FileRow from "components/file-components/file-row";

interface CourtInfoCardProps {
  court_reg: string;
  type: string;
  date: string;
  court_info?: string;
  court_name?: string | null;
  court_level?: string | null;
  court_region?: string | null;
  court_zone?: string | null;
  court_woreda?: string | null;
  court_type?: string | null;
  court_appeal_number?: string | null;
  court_summons?: File[];
  opening_date?: string | null;
  first_hearing_date?: string | null;
  hearing_date?: string | null;
  action_status?: string | null;
  hasLowerCourtData?: boolean;
  hasHigherCourtData?: boolean;
  onSubmitToCourt?: () => void;
  isTransfering?: boolean;
  fileRowProps?: any;
}

export default function AppealCourtInfoCard({
  court_reg,
  type,
  date,
  court_info,
  court_name,
  court_level,
  court_type,
  court_appeal_number,
  court_summons,
  opening_date,
  first_hearing_date,
  hearing_date,
  action_status,
  hasLowerCourtData,
  onSubmitToCourt,
  hasHigherCourtData,
  isTransfering,
  fileRowProps,
}: CourtInfoCardProps) {
  const isHigherCourt = type.toLowerCase() === "higher";
  const showSubmitButton =
    isHigherCourt &&
    action_status === AssetAppealRequestActionStatusEnum.APPEAL_APPROVED &&
    hasLowerCourtData &&
    hasHigherCourtData;

  return (
    <div className="court-card-container w-full">
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col">
          <p className="court-card-label">Court Registration</p>
          <p className="court-card-value">{court_reg}</p>
        </div>
        {type && (
          <div className="flex flex-col">
            <p className="court-card-label">Type</p>
            <p className="court-card-value">{type}</p>
          </div>
        )}
        <div className="flex flex-col p-2 rounded bg-black text-white text-sm ">
          <p>Appointment Date</p>
          <p className="text-sm text-white">{date}</p>
        </div>
      </div>

      <div className="mt-3">
        <p
          className="court-card-title mb-2 font-semibold"
          style={{ fontWeight: "600 " }}
        >
          Court Full Information
        </p>
      </div>

      {/* Court Details - Label and Value in one row horizontally */}
      <div className="mt-2 space-y-2">
        {court_name && (
          <div className="flex items-center gap-3 justify-between w-full">
            <span className="court-card-label min-w-[100px]">Court Name:</span>
            <span className="court-card-value">{court_name}</span>
          </div>
        )}
        {court_level && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Court Level:</span>
            <span className="court-card-value">{court_level}</span>
          </div>
        )}
        {court_type && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Court Type:</span>
            <span className="court-card-value">{court_type}</span>
          </div>
        )}
        {court_appeal_number && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">
              Appeal Number:
            </span>
            <span className="court-card-value">{court_appeal_number}</span>
          </div>
        )}

        {Array.isArray(court_summons) &&
          court_summons?.length > 0 &&
          court_summons?.map((file: any, index) => (
            <FileRow
              file={file}
              {...fileRowProps}
              w="w-full"
              key={file.document_uuid || index}
            />
          ))}
        {opening_date && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">
              Opening Date:
            </span>
            <span className="court-card-value">
              {opening_date.split("T")[0]}
            </span>
          </div>
        )}
        {first_hearing_date && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">
              First Hearing:
            </span>
            <span className="court-card-value">
              {first_hearing_date.split("T")[0]}
            </span>
          </div>
        )}
        {hearing_date && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">
              Hearing Date:
            </span>
            <span className="court-card-value">
              {hearing_date.split("T")[0]}
            </span>
          </div>
        )}
      </div>

      {showSubmitButton && (
        <div className="flex justify-end mt-6">
          <button
            onClick={onSubmitToCourt}
            disabled={isTransfering}
            className="bg-red-600 text-white hover:bg-gray-700 px-6 py-2 rounded-lg transition-colors text-sm font-semibold"
          >
            {isTransfering ? "Submitting..." : "Forward To Higher Admin"}
          </button>
        </div>
      )}
    </div>
  );
}
